<!--
// Copyright © 2026 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
-->
<script context="module" lang="ts">
  const plainTextLanguages = new Set(['', 'plaintext', 'text'])

  /**
   * Human readable name of a code block language, shared by the read-only markup renderers.
   * Absent, `plaintext` and `text` languages are all shown as `Plain text`.
   */
  export function formatCodeBlockLanguage (language: string | null | undefined): string {
    const normalized = (language ?? '').trim()
    return plainTextLanguages.has(normalized.toLowerCase()) ? 'Plain text' : normalized
  }
</script>

<script lang="ts">
  import view from '@hcengineering/view'
  import { ButtonIcon } from '@hcengineering/ui'
  import { copyTextToClipboard } from '../../utils'

  export let value = ''

  let copied = false

  async function copy (): Promise<void> {
    try {
      await copyTextToClipboard(value)
      copied = true
    } catch {
      copied = false
    }
  }

  function handleClick (event: MouseEvent): void {
    event.stopPropagation()
    event.preventDefault()
    void copy()
  }
</script>

<ButtonIcon
  icon={copied ? view.icon.CheckCircle : view.icon.Copy}
  iconSize="small"
  size="small"
  kind="tertiary"
  tooltip={{ label: copied ? view.string.Copied : view.string.CopyToClipboard }}
  on:click={handleClick}
/>
